export default __webpack_public_path__ + "static/media/me3_prepdigital_laptop.e3db3ee2.png";